import { render, staticRenderFns } from "./LoginByToken.vue?vue&type=template&id=0d72f5f1&"
import script from "./LoginByToken.vue?vue&type=script&lang=js&"
export * from "./LoginByToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports